import _ from "underscore";
import * as aj from "../aj/index";
import { PRIORITY } from "./types";
import { completed, failed } from "../utils/ajex";
import { CLEAR_PRIORITIES, PRIORITY_LOAD_ITEMS, PRIORITY_REORDER_ITEMS } from "../actions/types";


export function getDefaultState() {
    return {
        items: [],
    }
}

export const PriorityStore = aj.createStore(PRIORITY, (state = getDefaultState(), action) => {

    switch(action.type) {
        case completed(PRIORITY_LOAD_ITEMS):
            return _.assign(state, {items: action.items, orderedValues: null});
        case PRIORITY_REORDER_ITEMS:
            return _.assign(state, {items: action.items});
        case CLEAR_PRIORITIES:
            return _.assign(state, getDefaultState());
    }

})